var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalanceHeld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4C0.5 2.067 2.067 0.5 4 0.5H36C37.933 0.5 39.5 2.067 39.5 4V36C39.5 37.933 37.933 39.5 36 39.5H4C2.067 39.5 0.5 37.933 0.5 36V4Z",
    fill: "#EFE8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4C0.5 2.067 2.067 0.5 4 0.5H36C37.933 0.5 39.5 2.067 39.5 4V36C39.5 37.933 37.933 39.5 36 39.5H4C2.067 39.5 0.5 37.933 0.5 36V4Z",
    stroke: "#CCB1FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 23.7V23.81C20 24.09 19.78 24.31 19.5 24.31H10.5C10.22 24.31 10 24.09 10 23.81V23.7C10 21.94 10.44 21.5 12.22 21.5H17.78C19.56 21.5 20 21.94 20 23.7Z",
    fill: "#9F55FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 25.3101C10.22 25.3101 10 25.5301 10 25.8101V26.8101V27.8001C10 29.5601 10.44 30.0001 12.22 30.0001H17.78C19.56 30.0001 20 29.5601 20 27.8001V26.8101V25.8101C20 25.5301 19.78 25.3101 19.5 25.3101H10.5Z",
    fill: "#9F55FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30 23C30 26.87 26.87 30 23 30L24.05 28.25",
    stroke: "#9F55FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17C10 13.13 13.13 10 17 10L15.95 11.75",
    stroke: "#9F55FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 19C28.9853 19 31 16.9853 31 14.5C31 12.0147 28.9853 10 26.5 10C24.0147 10 22 12.0147 22 14.5C22 16.9853 24.0147 19 26.5 19Z",
    fill: "#9F55FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceHeld);
export default __webpack_public_path__ + "static/media/balance_held.e758f05b2f320750cee3ef9392ff324e.svg";
export { ForwardRef as ReactComponent };